<template>
  <div>
    <!-- Search form -->
    <div class="flex flex-wrap mt-6 -ml-1">
      <div
        v-for="category in categories"
        :key="category.id"
        @click="category_id = category.id"
        :class="['simple-btn', isSelected(category.id) ? 'btn-gold' : 'btn-mixed', 'btn-ghost w-full lg:w-auto lg:flex-grow mt-2 ml-1']"
      >{{ category.name.toUpperCase() }}</div>
    </div>

    <!-- Posts -->
    <a name="blogposts"></a>
    <div class="flex flex-wrap mt-8 -ml-10">
      <blog-card v-for="post in posts" :post="post" :key="post.id"></blog-card>
    </div>
  </div>
</template>

<script>
import { filter } from 'lodash';
import BlogCard from './BlogCard';

export default {
  components: {
    'blog-card': BlogCard,
  },

  data() {
    return {
      category_id: null,
      categories: [
        { id: null, name: 'LATEST POSTS' },
        ...window['post-categories'],
      ],
    };
  },

  computed: {
    posts() {
      if (this.category_id === null) {
        return window.posts;
      }

      return filter(window.posts, { category_id: this.category_id });
    },
  },

  methods: {
    isSelected(key) {
      return this.category_id === key;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-button {
  @apply w-full mt-2;
}

@screen lg {
  .filter-button {
    @apply w-auto flex-grow;
    @apply mt-0 ml-1;
  }
}
</style>
